<ng-select class="multi-email-input" [items]="items" [multiple]="true" [addTag]="addTag" addTagText="Add"
  [hideSelected]="true" [selectOnTab]="true" [clearable]="!readonly && !disabled" [searchable]="!readonly"
  [readonly]="readonly || disabled" [ngModel]="emails" (ngModelChange)="onModelChange($event)"
  [placeholder]="emails.length ? '' : (placeholder || '')" [labelForId]="inputId" [appendTo]="appendTo"
  notFoundText="Type an email address" (search)="onSearch($event)" (blur)="onBlur()"
  [class.is-invalid]="!!invalidText">
</ng-select>
<small class="text-danger d-block" *ngIf="invalidText">{{ invalidText }}</small>
